import { useState, useEffect } from 'react';
import {
  getActiveSurvey,
  getSurveyById,
  getSurveyResponses,
} from '../services/survey_services';
import { useAccount } from '../contexts/Account';
import eventBus, { eventBusValues } from '../eventBus';

function useSurveyViewer(surveyId) {
  const [surveyResults, setSurveyResults] = useState([
    { count: 0, percentage: 0, body: '', index: 0 },
    { count: 0, percentage: 0, body: '', index: 1 },
  ]);
  const [surveyAnswers, setSurveyAnswers] = useState([]);
  const [responseOptions, setResponseOptions] = useState([]);
  const [loadingSurveyResults, setLoadingSurveyResults] = useState(true);
  const [body, setBody] = useState('');

  const { accountDetails } = useAccount();

  useEffect(async () => {
    let surveyCallsId = surveyId;
    let questionData;
    if (!surveyId) {
      const activeSurveyResponse = await getActiveSurvey({
        COMPANY_ID: accountDetails.id,
      });
      surveyCallsId = activeSurveyResponse.data.getActiveSurvey[0]?.surveyId;
      questionData = activeSurveyResponse.data.getActiveSurvey;
    }

    const [surveyQuestion, responses] = await Promise.all([
      surveyId ? getSurveyById({ SURVEY_ID: surveyId }) : () => null,
      getSurveyResponses({
        SURVEY_ID: surveyCallsId,
        USER_ID: '',
      }),
    ]);
    if (surveyId) {
      questionData = surveyQuestion.data.getActiveSurvey;
    }

    setResponseOptions(questionData[0]?.responseOptions || []);
    setBody(questionData[0]?.body || '');
    setSurveyAnswers(responses.data.getSurveyResponses);

    eventBus.on(eventBusValues.surveyAnswered, (activity) => {
      if (activity?.survey?.response) {
        setSurveyAnswers((prevAnswers) => [
          ...prevAnswers,
          { body: activity.survey.response, id: new Date().toISOString() },
        ]);
      }
    });

    eventBus.on('surveyUpdated', (data) => {
      setBody({ body: data.question });
      setResponseOptions(data.newOptions || []);
      setSurveyAnswers([]);
    });

    return () => {
      eventBus.remove(eventBusValues.surveyAnswered);
      eventBus.remove('surveyUpdated');
    };
  }, []);

  useEffect(() => {
    const data = {};
    responseOptions.forEach((option, index) => {
      data[option] = {
        count: 0,
        body: option,
        percentage: 0,
        index: index,
      };
    });
    surveyAnswers.forEach((answer) => {
      if (data[answer.body]) {
        data[answer.body].count += 1;
        data[answer.body].percentage = Math.round(
          (data[answer.body].count / surveyAnswers.length) * 100
        );
      }
    });
    setSurveyResults(
      Object.keys(data)
        .map((key) => data[key])
        .sort((a, b) => a.index - b.index)
    );
    setLoadingSurveyResults(false);
  }, [surveyAnswers.length, responseOptions.length]);

  return [surveyResults, loadingSurveyResults, body];
}
export default useSurveyViewer;
